/**
 * @file 自主认证引导
 * @author (chenyuyang@baidu.com)
 */
import React from 'react';
import secm from '@baidu/sec-monitor';
import company1 from '../../asset/img/companyGuide/step-1.png';
import company2 from '../../asset/img/companyGuide/step-2.png';
import company3 from '../../asset/img/companyGuide/step-3.png';
import companyCard from '../../asset/img/companyGuide/company-2.png';
import hiQrCode from '../../asset/img/companyGuide/hiQrCode.png';
import favicon from '../../asset/img/favicon.png';
import './style.less';

class CompanyGuide extends React.Component {
    state = {
        baiduCloudUrl: 'https://console.bce.baidu.com/spns/#/'
    };
    jump = (url, type) => {
        const actionType = type || 'spns';
        _hmt.push(['_trackEvent', 'companyguide', 'click', actionType]);
        secm.action('companyguide', 'click', actionType).then(res => {
            const ele = document.createElement('a');
            ele.setAttribute('href', url);
            ele.setAttribute('target', '_blank');
            ele.click();
        });
    };
    render() {
        const {baiduCloudUrl} = this.state;
        return (<div className="company-guide">
            <div className="step-header">
                <p>四步完成企业号码认证</p>
                <p className="top-tip">以下认证需在<span className="strong">百度云</span>平台操作，请您仔细阅读</p>
            </div>
            <div className="step-container">
                <div className="step-wrapper">
                    <div className="step-title">第一步：</div>
                    <div className="step-content">
                        <div className="step-info-wrapper">
                            <div className="step-card">
                                <div className="step">
                                    <span className="step-num">1</span>
                                    <span className="step-tip">进入「百度云控制台首页」，选择「产品服务」-「号码安全服务」</span>
                                </div>
                                <div className="step-info">
                                    <img className="step-info-img" src={company1}></img>
                                </div>
                            </div>
                            <div className="step-card">
                                <div className="step">
                                    <span className="step-num">2</span>
                                    <span className="step-tip">选择「付费企业号码认证」</span>
                                </div>
                                <div className="step-info">
                                    <img className="step-info-img" src={company2}></img>
                                </div>
                            </div>
                            <div className="step-card">
                                <div className="step">
                                    <span className="step-num">3</span>
                                    <span className="step-tip">点击「新增付费企业号码认证」完成资质提交</span>
                                </div>
                                <img className="step-info-img" src={company3}></img>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="step-wrapper">
                    <div className="step-title">第二步：</div>
                    <div className="step-content">
                        <div className="content-wrapper">
                            <p className="step-info-tip">等待审核结果</p>
                            <div>预计在7个工作日完成审核，您可以在<span className="strong">百度云</span>查看审核进度</div>
                        </div>
                    </div>
                </div>
                <div className="step-wrapper">
                    <div className="step-title">第三步：</div>
                    <div className="step-content">
                        <div className="content-wrapper">
                            <p className="step-info-tip">获得名片，展示到百度搜索结果</p>
                            <img className="step-img" src={companyCard} />
                        </div>
                    </div>
                </div>
                <div className="step-wrapper">
                    <div className="step-title">第四步：</div>
                    <div className="step-content">
                        <div className="content-wrapper">
                            <div className="step-info-tip">前往<span className="strong">百度云</span>平台进行认证</div>
                            <div>
                                认证需登录您的百度云账号并进行企业认证，点击链接跳转
                                <span
                                    className="link"
                                    onClick={() => {this.jump(baiduCloudUrl, 'spns');}}
                                >{baiduCloudUrl}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="foot">
                {/* <Button
                    label="开始认证"
                    className="btn"
                    onClick={() => {this.jump(baiduCloudUrl, 'spns');}}
                ></Button> */}
            </div>
            <div className="qr-codes">
                <p className="header-tip">如有疑问，可联系咨询邮箱</p>
                <p className="header-tip-info">
                    <span
                        onClick={() => {this.jump('mailto:haoma_support@baidu.com', 'email');}}
                        className="link"
                    >haoma_support@baidu.com</span>
                </p>
                <div className="qr-code-wrapper">
                    <h4>如流服务号</h4>
                    <div className="qr-code">
                        <img src={hiQrCode}></img>
                    </div>
                    <div className="bottom-tip">
                        <img
                            style={{'width': '20px', 'height': '20px', 'flexShrink': 0}}
                            src={favicon}></img>
                        <div className="bottom-tip-info">
                            <p>百度安全号码服务</p>
                            <p>扫一扫上面的二维码，关注我</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}

export default CompanyGuide;